import React, { lazy, useRef, useState } from "react";

/** Common Components */
import CardSection from "../../components/ui/card/CardSection";
import CenterModal from "../../components/ui/centerModal/CenterModal";
import AssignUnassignMergeField from "./components/assignUnassignMerge/AssignUnassignMergeField";
import LiabilityBasisTypeCombinationList from "./components/liabilityBasisTypeCombinationList/LiabilityBasisTypeCombinationList";

/** CSS Files */
import "./LiabilityTypes.scss";

/** Lazily Loaded Components */
const LiabilityTypesList = lazy(() =>
  import("./components/liabilityTypesList/LiabilityTypesList")
);
const AddEditLiabilityTypes = lazy(() =>
  import("./components/addEditLiabilityTypes/AddEditLiabilityTypes")
);

const LiabilityTypes = () => {
  const liabilityGridRef = useRef();
  const BasisTypeGridRef = useRef();

  const [isEdit, setIsEdit] = useState(false);
  const [editUserData, setEditUserData] = useState(null);
  const [isUserModelOpen, setIsUserModelOpen] = useState(false);
  const [isLiabilityListModelOpen, setIsLiabilityListModelOpen] =
    useState(false);
  const [selectRow, setSelectrow] = useState("");
  const [selectedLiabilityName, setSelectedLiabilityName] = useState("");
  const [listData, setListData] = useState([]);

  const handleAddUserClick = () => { 
    setIsEdit(false);
    setEditUserData(null);
    setIsUserModelOpen(true);
  };

  const handleCloseModel = () => {
    setIsEdit(false);
    setEditUserData(null);
    setIsUserModelOpen(false);
    setIsLiabilityListModelOpen(false);
  };

  const handleEditClick = (data) => {
    setIsEdit(true);
    setEditUserData(data);
    setIsUserModelOpen(true);
  };
  
  const handleViewClick = (data) => {
    setIsLiabilityListModelOpen(true);
  };

  const handleSuccess = () => {
    handleCloseModel();
    if (liabilityGridRef.current) {
      liabilityGridRef.current?.refreshGrid();
    }
  };

  return (
    <>
      <div className="liability-types">
        <div className="list-of-liabilities-sec">
          <CardSection
            cardTitle={"List of Liabilities"}
            rightButton={true}
            buttonClassName={"blue-btn"}
            titleButtonClick={handleAddUserClick}
            buttonText={"ADD"}
            searchInput={false}
            isButtonVisible={true}
            isButtonLoading={""}
            isIcon={true}
            iconClass="uil:plus"
          >
            <div className="only-list-body-scroll">
              <LiabilityTypesList
                ref={liabilityGridRef}
                onEdit={handleEditClick}
                onView={handleViewClick}
                setSelectrow={setSelectrow}
                setSelectedLiabilityName={setSelectedLiabilityName}
              />
            </div>
          </CardSection>
        </div>
        <div className="assign-basis-type-sec">
          <CardSection
            cardTitle={`Assign basis type${
              selectedLiabilityName ? `: ${selectedLiabilityName}` : ""
            }`}
            rightButton={true}
            buttonClassName={"blue-btn"}
            buttonText={"ADD"}
            isButtonVisible={true}
            isIcon={true}
            iconClass="uil:plus"
            titleButtonClick={handleViewClick}
          >
            <div className="only-list-body-scroll">
              <LiabilityBasisTypeCombinationList
                ref={BasisTypeGridRef}
                onEdit={handleEditClick}
                onView={handleViewClick}
                selectRow={selectRow}
                selectedLiabilityName={selectedLiabilityName}
                listData={listData}
                setListData={setListData}
              />
            </div>
          </CardSection>
        </div>
      </div>
      <CenterModal
        modalTitle={isEdit ? `Update Liability Types` : `Add Liability Types`}
        modalSize={"w-40"}
        isOpen={isUserModelOpen}
        onClose={handleCloseModel}
        transition={"grow"}
      >
        <AddEditLiabilityTypes
          isEdit={isEdit}
          isOpen={isUserModelOpen}
          initData={editUserData}
          onClose={handleCloseModel}
          onSuccess={handleSuccess}
        />
      </CenterModal>

      <CenterModal
        modalTitle={`Assign Unassign Merge Field`}
        modalSize={"w-60"}
        isOpen={isLiabilityListModelOpen}
        onClose={handleCloseModel}
        transition={"grow"}
      >
        <AssignUnassignMergeField
          selectRow={selectRow}
          setListData={setListData}
        />
      </CenterModal>
    </>
  );
};

export default LiabilityTypes;
